import React from 'react';

import BaseEntry from '../BaseEntry/BaseEntry';
import FormInput from '../../components/FormInput/FormInput';

import { Message, Button } from 'semantic-ui-react';
import params from '../../qp';
import { Users } from '../../api';
import { AppContext } from '../../components/AppContext/AppContext';

import './ResetPassword.scss';

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      passwordError: '',
      confirm: '',
      confirmError: '',
      formError: '',
      isSubmitting: false,
    };
  }

  validateForm = () => {
    const { password, confirm } = this.state;

    let update = false;
    let newState = {};
    if (!password) {
      newState.passwordError = 'New password is required';
      newState.formError =
        'Password reset failed. Please check your entries and try again.';
      update = true;
    }
    if (!confirm) {
      newState.confirmError = 'Confirm new password is required';
      newState.formError =
        'Password reset failed. Please check your entries and try again.';
      update = true;
    }
    if (confirm !== password) {
      newState.confirmError = 'Both passwords must match';
      newState.formError =
        'Password reset failed. Please check your entries and try again.';
      update = true;
    }
    if (update) {
      this.setState(newState);
    }
    return !update;
  };

  handleChangePassword = e =>
    this.setState({ password: e.target.value, passwordError: '' });
  handleChangeConfirm = e =>
    this.setState({ confirm: e.target.value, confirmError: '' });

  handleSubmit = async e => {
    const code = params.get('code');
    e.preventDefault();
    if (!this.validateForm()) {
      return;
    }
    const { password } = this.state;
    this.setState({ isSubmitting: true });

    Users.passwordReset({ code, password })
      .then(res => {
        this.props.addToast({
          type: 'success',
          message: 'Your password has been reset successfully!',
        });
        this.props.history.push('/login');
      })
      .catch(err => {
        const errMsg =
          (err.response && err.response.body && err.response.body.error) ||
          'We were unable to reset the password.';
        this.props.addToast({
          type: 'error',
          message:
            'Your password could not be reset at this time. Please try again.',
        });
        this.setState({
          formError: errMsg,
        });
      });

    this.setState({ isSubmitting: false });
  };

  handleCancel = () => {
    this.props.history.push('/login');
  };

  render() {
    const {
      password,
      passwordError,
      confirm,
      confirmError,
      formError,
      isSubmitting,
    } = this.state;
    return (
      <BaseEntry>
        <form className="ResetPassword" onSubmit={this.handleSubmit}>
          {!!formError && <Message negative>{formError}</Message>}
          <h4 className="heading">Reset Your Password</h4>
          <p className="description">
            Enter and confirm your new password below.
          </p>
          <FormInput
            autoFocus
            label="NEW PASSWORD"
            error={!!passwordError}
            errorMessage={passwordError}
            value={password}
            onChange={this.handleChangePassword}
            type="password"
          />
          <FormInput
            label="CONFIRM NEW PASSWORD"
            error={!!confirmError}
            errorMessage={confirmError}
            value={confirm}
            onChange={this.handleChangeConfirm}
            type="password"
          />
          <div className="form-actions">
            <Button type="submit" primary loading={isSubmitting}>
              RESET PASSWORD
            </Button>
            <Button
              type="button"
              className="ghost dark"
              onClick={this.handleCancel}>
              CANCEL
            </Button>
          </div>
        </form>
      </BaseEntry>
    );
  }
}
const WrappedResetPassword = props => (
  <AppContext.Consumer>
    {({ addToast }) => <ResetPassword {...props} addToast={addToast} />}
  </AppContext.Consumer>
);

export default WrappedResetPassword;
